import { useLocation } from 'react-router-dom'
import { encodingJSON } from 'ui-seeker/utils'

import { useCommonFilters } from './index'

export default function useShareFilters() {
    const { pathname } = useLocation()

    const {
        hotels, dateRange, maxDate, customDateRange, deviceParity, rawRooms, otherSites,
		boardID, roomID, adults, kids, occupancy, mainHotels, devices, providerID,
		sites, sitesList, nights, priceType, otas, markets, metas, rateID,
        market, info, currency, connectivities, idMainHotelCustomPinned
    } = useCommonFilters()

    const buildUrl = () => {
        const completeURL = window.location.href
        const [rootURL] = completeURL.split(pathname)
        return `${rootURL}${pathname}?sp=${buildFilterParams()}`
    }

    const buildRelativeUrl = () => {
        return `${pathname}?sp=${buildFilterParams()}`
    }

    const buildFilterParams = (stringify=false) => {
        const filterParams = {
            mainHotels: mainHotels,
            market,
            currency,
            parity: { metas, otas, deviceParity, markets, info },
            items: {
                hotels, dateRange, maxDate, customDateRange, boardID, roomID, rateID, adults, kids, occupancy, sites,
                sitesList, nights, priceType, devices, providerID, otherSites, rawRooms, connectivities,
                idMainHotelCustomPinned
            }
        }

        if (stringify)
            return filterParams

        return encodingJSON(filterParams)
    }

	return {
        buildFilterParams, buildUrl, buildRelativeUrl
    }
}